import { combineReducers } from 'redux';

import * as actionTypes from '@store/supplier/action-types';

const getAllSuppliers = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ALL_SUPPLIER_TYPE_REQUEST:
		case actionTypes.FETCH_ALL_SUPPLIER_TYPE_FAILURE:
			return state;
		case actionTypes.FETCH_ALL_SUPPLIER_TYPE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSuplierCategory = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_CATEGORY_TYPE_REQUEST:
		case actionTypes.FETCH_SUPPLIER_CATEGORY_TYPE_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_CATEGORY_TYPE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllCountries = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_COUNTRY_REQUEST:
		case actionTypes.FETCH_COUNTRY_FAILURE:
			return state;
		case actionTypes.FETCH_COUNTRY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSupplierCityByCountry = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_CITY_REQUEST:
		case actionTypes.FETCH_CITY_FAILURE:
			return state;
		case actionTypes.FETCH_CITY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSuppliersDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_DETAILS_REQUEST:
		case actionTypes.FETCH_SUPPLLIER_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSuppliersPhotoGallarey = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_PHOTO_GALLAREY_REQUEST:
		case actionTypes.FETCH_SUPPLIER_PHOTO_GALLAREY_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_PHOTO_GALLAREY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSuppliersCertificates = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_CERTIFICATES_REQUEST:
		case actionTypes.FETCH_SUPPLIER_CERTIFICATES_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_CERTIFICATES_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSuppliersReviewSummaries = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_REVIEW_SUMMARIES_REQUEST:
		case actionTypes.FETCH_SUPPLIER_REVIEW_SUMMARIES_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_REVIEW_SUMMARIES_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const initialTagsState = {
	additionalTags: [],
	strengthTags: [],
	materialTags: [],
	clientTags: [],
	allTags: []
};

const getAllTags = (state = initialTagsState, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_STRENGTH_REQUEST:
		case actionTypes.FETCH_STRENGTH_FAILURE:
			return state;
		case actionTypes.FETCH_STRENGTH_SUCCESS:
			if (payload.type === 'SUPPLIER_STRENGTH') {
				return {
					...state,
					strengthTags: [...payload.data]
				};
			}
			if (payload.type === 'SUPPLIER_ADDITIONAL_TAG') {
				return {
					...state,
					additionalTags: [...payload.data]
				};
			}
			if (payload.type === 'MATERIAL_SUSTAINABLE_TAG') {
				return {
					...state,
					materialTags: [...payload.data]
				};
			}

			if (payload.type === 'SUPPLIER_CLIENTS') {
				return {
					...state,
					clientTags: [...payload.data]
				};
			}
			if (payload.type === 'PRODUCT_SIZE_STANDARD') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'PRODUCT_RISE') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'PRODUCT_FITTING_TYPE') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'PRODUCT_LENGTH') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'PRODUCT_AVATAR') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'ARTWORK_MOOD_TAG') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'ARTWORK_PATTERN_TAG') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'ARTWORK_TAGS') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			if (payload.type === 'SKETCH_TAGS') {
				return {
					...state,
					allTags: [...payload.data]
				};
			}
			return state;
		default:
			return state;
	}
};

const initialReviewsState = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getSuppliersReviews = (state = initialReviewsState, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_REVIEWS_REQUEST:
		case actionTypes.FETCH_SUPPLIER_REVIEWS_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_REVIEWS_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_MORE_USERS_REVIEWS_SUCCESS:
			return {
				...state,
				...payload,
				data: removeDuplicateReview([...state.data, ...payload.data])
			};
		default:
			return state;
	}
};

const removeDuplicateReview = (reviews) => {
	return [...new Map(reviews.map((item) => [item.id, item])).values()];
};

const initialSupplierMaterials = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getAllSuppliersMaterials = (state = initialSupplierMaterials, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_REQUEST:
		case actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_FAILURE:
			return state;
		case actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS:
			return {
				...state,
				...payload,
				data: [...payload.data]
			};
		case actionTypes.FETCH_MORE_ALL_SUPPLIERS_MATERIALS_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
			};
		case actionTypes.FETCH_SEARCH_RESULT_SUPPLIERS_MATERIALS:
			return {
				...state,
				...payload,
				data: [...payload.data]
			};
		default:
			return state;
	}
};

const initialMaterialList = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getSupplierMaterialList = (state = initialMaterialList, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_MATERIAL_LIST_REQUEST:
		case actionTypes.FETCH_SUPPLIER_MATERIAL_LIST_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_MATERIAL_LIST_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_MORE_SUPPLIER_MATERIAL_LIST_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
			};
		default:
			return state;
	}
};

const getSupplier = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_SEARCH_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_SEARCH_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const initialSuppliersList = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getAllSuppliersList = (state = initialSuppliersList, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUPPLIER_LIST_FAILURE:
			return state;
		case actionTypes.FETCH_SUPPLIER_LIST_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_MORE_SUPPLIER_LIST_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
			};
		default:
			return state;
	}
};

const initialStateForFabricSearch = {
	materialId: null,
	isSuccess: false,
	searchKey: '',
	isDescriptionSearchOpen: false,
	descriptionSearchText: ''
};

const getFabricSearch = (state = initialStateForFabricSearch, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FABRIC_SEARCH_SUCCESS:
			return {
				...state,
				materialId: payload.materialId,
				isSuccess: payload.isSuccess
			};
		case actionTypes.GET_SEARCH_VALUE:
			return {
				...state,
				searchKey: payload
			};
		case actionTypes.IS_DESCRIPTION_SEARCH_OPEN:
			return {
				...state,
				isDescriptionSearchOpen: payload
			};
		case actionTypes.GET_DESCRIPTION_SEARCH_TEXT:
			return {
				...state,
				descriptionSearchText: payload
			};

		default:
			return state;
	}
};

const supplierReducer = combineReducers({
	allSuppliers: getAllSuppliers,
	allCategories: getSuplierCategory,
	allCountries: getAllCountries,
	allCities: getSupplierCityByCountry,
	allTags: getAllTags,
	suppliersDetails: getSuppliersDetails,
	suppliersPhotoGallarey: getSuppliersPhotoGallarey,
	suppliersCertificates: getSuppliersCertificates,
	suppliersReviewSummaries: getSuppliersReviewSummaries,
	suppliersReviews: getSuppliersReviews,
	allSuppliersMaterials: getAllSuppliersMaterials,
	supplierMaterialList: getSupplierMaterialList,
	supplier: getSupplier,
	allSuppliersList: getAllSuppliersList,
	fabricSearch: getFabricSearch
});

export default supplierReducer;
